import styles from './FinalCTA.module.css';
import { ScriptText } from '../shared/ScriptText';
import { StoreBadges } from '../shared/StoreBadges';
import { GrainOverlay } from '../shared/GrainOverlay';

export function FinalCTA() {
  return (
    <section className={styles.section}>
      <GrainOverlay />
      <div className={styles.inner}>
        <h2 className={`display ${styles.title}`}>
          Tonight could be <ScriptText rotate={-2}>different.</ScriptText>
        </h2>
        <p className={styles.sub}>
          Download free. Discover what you both want. No ads, no data sold — just you two.
        </p>
        <StoreBadges analyticsLocation="final_cta" />
      </div>
    </section>
  );
}
